const QuestionIcon = () => {
    return (
        <svg className={"svg-icon"}  width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.6113 21C17.5819 21 21.6113 16.9706 21.6113 12C21.6113 7.02944 17.5819 3 12.6113 3C7.64077 3 3.61133 7.02944 3.61133 12C3.61133 16.9706 7.64077 21 12.6113 21Z"
                stroke="#141615" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M12.6113 18.375C13.4398 18.375 14.1113 17.7034 14.1113 16.875C14.1113 16.0466 13.4398 15.375 12.6113 15.375C11.7829 15.375 11.1113 16.0466 11.1113 16.875C11.1113 17.7034 11.7829 18.375 12.6113 18.375Z"
                fill="#141615" />
            <path
                d="M12.6113 13.5C13.2047 13.5 13.7847 13.3241 14.278 12.9944C14.7714 12.6648 15.1559 12.1962 15.383 11.6481C15.61 11.0999 15.6694 10.4967 15.5537 9.91473C15.4379 9.33279 15.1522 8.79824 14.7326 8.37868C14.3131 7.95912 13.7785 7.6734 13.1966 7.55765C12.6147 7.44189 12.0115 7.5013 11.4633 7.72836C10.9151 7.95543 10.4466 8.33994 10.1169 8.83329C9.78728 9.32664 9.61133 9.90666 9.61133 10.5"
                stroke="#141615" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default QuestionIcon